<template>
	<div class="project-list-row" @click="onChange">
		<div class="project-list-row-content d-flex pa-2">	
			<div style="width: 100%;">
				<div class="name">{{ this.item.name }}</div>
				<GBClasses
					:items="this.item.classes"
					:max_width=278
					:all_show=false
				/>
			</div>
			<div class="project-list-row-select">
				<v-avatar v-if="selected" color="orange" size="32" class="mt-1">
					<v-icon color="white">done</v-icon>
				</v-avatar>
				<v-avatar v-else size="31" class="mt-1 no-selected"></v-avatar>
			</div>
		</div>
	</div>
</template>
<script>
import GBClasses from './GBClasses';
export default {
	name: 'GBProjectListRow',
	props: [
		"item",
		"selectedProject",
	],
	components: {
		GBClasses,
	},
	methods: {
		onChange: function() {
			this.$emit("change-select-project", {
				item: this.item,
				select: !this.selected,
			});
		},
	},
	computed: {
		selected: function() {
			return this.selectedProject.some((p) => {
				return p.code === this.item.code;
			});
		},
	},
};
</script>
<style>
	.project-list-row {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		background-color: #fefefe;
		border-bottom: solid 1px #a9a9a9;
		cursor: pointer;
		user-select: none;
	}
	.project-list-row:hover {
		background-color: #eee;
	}
	.project-list-row-content {
		padding-right: 14px !important;
	}
	.project-list-row-content .name{
		max-width: 290px;
		word-wrap: break-word;
	}
	.project-list-row-select {
		display: flex;
		align-items: center;
	}
	.no-selected {
		border: solid 1px orange;
		border-radius: 50%;
		background-color: #EEEEEE;
	}
</style>
